<div class="lcl-package-units-switch" *ngIf="!isUpdatedLayout">
  <app-switch-button
    [control]="weightSwitchControl"
    [textLeft]="('LENGTH_UNIT.CENTIMETER' | translate) + '/' + ('WEIGHT_UNIT.KG' | translate)"
    [textRight]="('LENGTH_UNIT.INCH' | translate) + '/' + ('WEIGHT_UNIT.LB' | translate)"
  ></app-switch-button>
</div>

<div
  class="lcl-package-row"
  [ngClass]="{ 'is-old': !isUpdatedLayout }"
  *ngFor="let package of packagesFormArray.controls; let i = index; let last = last"
>
  <ng-container *ngIf="!isUpdatedLayout">
    <app-lcl-shipping-package-edit-old
      [formGroup]="package"
      [index]="i"
      [isLastest]="packagesFormArray.controls.length === 1"
      [isSidebar]="true"
      [isAdminView]="isAdminView"
      (removePackage)="onRemovePackage($event)"
      (formUpdated)="onFormUpdated($event)"
    ></app-lcl-shipping-package-edit-old>
  </ng-container>

  <ng-container *ngIf="isUpdatedLayout">
    <app-lcl-shipping-package-edit
      #packagesView
      [formGroup]="package"
      [index]="i"
      [isLastest]="packagesFormArray.controls.length === 1"
      [isSidebar]="true"
      [isAdminView]="isAdminView"
      [isShowClear]="isShowClear"
      (removePackage)="onRemovePackage($event)"
      (formUpdated)="onFormUpdated($event)"
    ></app-lcl-shipping-package-edit>
  </ng-container>
</div>

<div class="row">
  <div class="col-12 col-md-6 my-auto text-center text-md-left" *ngIf="!isUpdatedLayout || isShowAdd">
    <button type="button" class="btn btn-add-package" (click)="addPackage()">
      <div class="icon-plus-container">
        <icon-plus></icon-plus>
      </div>
      {{ "BUTTON.ADD_PACKAGE" | translate }}
    </button>
  </div>

  <div
    class="col-12 text-center"
    [ngClass]="{ 'col-md-6 text-md-right': !isUpdatedLayout || isShowAdd, 'text-center': isUpdatedLayout && !isShowAdd }"
  >
    <button type="submit" class="btn btn-primary" (click)="onSubmit()">
      {{ "BUTTON.SAVE" | translate }}
    </button>
  </div>
</div>
